// Prints a full HTML document without the "about:blank" title/URL that shows up
// in the browser's print header/footer. That happens because `window.open('', '_blank')`
// opens a popup whose location.href never leaves about:blank — document.write() only
// replaces the in-memory document, it doesn't navigate the window. Printing instead via
// a hidden same-page iframe means the print context inherits the real parent page's
// title and URL, so the header/footer shows something meaningful.
export function printHtml(html) {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
  };

  iframe.onload = () => {
    const win = iframe.contentWindow;
    const doPrint = () => {
      try {
        win.focus();
        win.print();
      } catch (e) {
        console.error('[printHtml]', e);
      }
      // onafterprint doesn't fire in every browser, so also clean up on a timer.
      try { win.onafterprint = cleanup; } catch (e) {}
      setTimeout(cleanup, 2000);
    };
    // Web fonts (e.g. Inter, loaded via @import) fetch asynchronously and don't
    // block `onload` — printing immediately can fire before they're applied,
    // silently falling back to a wider/bolder system font that also throws off
    // line wrapping (and therefore where page breaks land). Wait for fonts to
    // finish loading first, capped so a slow/offline network can't hang the print.
    const fontsReady = (win.document.fonts && win.document.fonts.ready) || Promise.resolve();
    Promise.race([fontsReady, new Promise(r => setTimeout(r, 1200))]).then(doPrint, doPrint);
  };

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
}
